import React, { useEffect, useState } from 'react';
import { Form, FormGroup, Label, Input, Button, InputGroup, InputGroupAddon, Spinner,  CustomInput, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Badge, } from 'reactstrap';
import { Link } from 'react-router-dom';
import { FaCheck, FaPlus } from 'react-icons/fa';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { getOfferTypes } from 'service/offertype.service';
import { addOffer } from 'service/offer.service';
import { addOfferTags } from 'service/offerTags.service';
import { addBulkOfferTags } from 'service/offerTags.service';
import { updateOffer } from 'service/offer.service';
import { getOfferStatus } from 'service/offerstatus.service';
import { getOfferById } from 'service/offer.service';
import { deleteOfferTags } from 'service/offerTags.service';
import { addOfferBadges } from 'service/offerBadges.service';
import { updateOfferBadges } from 'service/offerBadges.service';
import LoadingSpinner from 'layouts/LoadingSpinner/LoadingSpinner';
import { updateOfferTags } from 'service/offerTags.service';

const Step1Form = ({ formData, handleChange, handleNextStep }) => {
    const [offerData, setFormData] = useState({
        id: 0,
        offer_name: '',
        offer_short_description: '',
        offer_long_description: '',
        offer_package_name: '',
        advertiser: '',
        offer_small_icon: '',
        offer_medium_icon: '',
        offer_large_icon: '',
        offer_banner_image: '',
        offer_revenue: 0,
        offer_payout: 0,
        offer_user_reward: 0,
        offer_type: '',
        offer_app_preview_required: false,
        offer_app_title: '',
        offer_app_description: '',
        offer_video_link: "",
        offer_tags: [],
        offer_badges: [],
        status: 'pause',
        user_conversion_count: 0,
        is_special_offer: false,
        is_video_available: false,
        is_promotional: false | null,
        enable_click_count: true,
    });
    const [tags, setTags] = useState([{ text: '', textColor: '#ffffff', backgroundColor: '', offerId: 0 }]);
    const [badges, setBadges] = useState({ text: '', textColor: '#ffffff', backgroundColor: '', offerId: 0, isActive: false, id:0 });
    // setFormData(formData);
    const [step, setStep] = useState(1);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [offerTypeData, setOfferTypeData] = useState([]);
    const [offerStatuses, setOfferStatuses] = useState([
        { value: 'live', label: 'Live' },
        { value: 'paused', label: 'Paused' },
      ]);
      const [notification, setNotification] = useState(null);
      const [dropdownOpen, setDropdownOpen] = useState(false);
      const [selectedOfferStatus, setSelectedOfferStatus] = useState('live');
      const [isPreloading, setIsPreLoaded] = useState(true);
    const modules = {
        toolbar: [
            ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
            ['blockquote', 'code-block'],
          
            [{ 'header': 1 }, { 'header': 2 }],               // custom button values
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
            [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
            [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
            [{ 'direction': 'rtl' }],                         // text direction
          
            [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
          
            [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
            [{ 'font': [] }],
            [{ 'align': [] }],
          
            ['clean']                                         // remove formatting button
          ],
        clipboard: {
            // toggle to add extra line breaks when pasting HTML:
            matchVisual: false,
        },
    }
    useEffect(() => {
        fetchOfferTypes();
        fetchOfferStatus();
        console.log(formData);
        setFormData((prevData) => ({
            ...prevData,
            ...formData
        }));
        setTags(formData.offer_tags);
        if(formData.offer_badges.length > 0){
            setBadges(formData.offer_badges[0]);
        }
        if(formData.id>0){
            fetchOfferById(formData.id);
        }
        
        setSelectedOfferStatus(formData.status);
      
    }, [formData]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));



    };




    const toggleDropdown = () => {
       setDropdownOpen(!dropdownOpen);
      }; 

      const updateOfferStatus = async(offerId, status) => {
      
        const data = await updateOffer(offerId, {status: status});
    
    
        console.log(data);
        if(data){
          
          setNotification({ type: "success", message: "Offer Status Updated" });
  
        }else{
          setNotification({ type: "error", message: "Unable to update offer status" });
        }
    
        setTimeout(() => {
          setNotification(null);
        }, 3000);  
    
      }
    
    const fetchOfferTypes = async () => {
        try {
            setIsPreLoaded(true);
            const offertype = await getOfferTypes();
            console.log(offertype);
            setOfferTypeData(offertype.data.offerTypeFeed);
            setIsPreLoaded(false);
        } catch (error) {
            console.error('Error fetching advertisers:', error);
        }
    };

    const fetchOfferStatus = async () => {
        try {
            setIsPreLoaded(true);
            const offertype = await getOfferStatus();
            console.log(offertype);
            setOfferStatuses(offertype.data.offerStatusFeed);
            setIsPreLoaded(false);
        } catch (error) {
            console.error('Error fetching advertisers:', error);
        }
    };
    
    const handleStatusChange = async (statusValue, offerId) => {
        // setSelectedOfferStatus((prevStatuses) => ({
        //   ...prevStatuses,
        //   [offerId]: statusValue,
        // }));
        console.log(statusValue);
        setSelectedOfferStatus(statusValue)
       await  updateOfferStatus(offerId, statusValue);
        fetchOfferById(offerId);
        // Perform any necessary logic or updates based on the selected status
        // ...
      };
      
      const  fetchOfferById = async (id) => {
        try {
            setIsPreLoaded(true);
          console.log(id);
          const data = await getOfferById(id);
          console.log(data);
          setIsPreLoaded(false);
          setSelectedOfferStatus(data.data.result.status)
          setFormData(data.data.result);
          if(data.data.result.offer_badges.length > 0){
            setBadges(data.data.result.offer_badges[0]);
        }
        } catch (error) {
          console.error("Error fetching offers:", error);
        }
      };

    const handleOfferChange = (e) => {
        const { name, value } = e.target;

        console.log(e.target);
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };
    const renderBadge = () => {
        const selectedStatus = selectedOfferStatus;
        console.log(selectedStatus);
        let color = "";
        console.log(selectedStatus);
        switch (selectedStatus) {
          case "live":
            color = "bg-gradient-success";
            break;
          case "paused":
            color = "bg-gradient-warning";
            break;
          case "removed":
            color = "bg-gradient-danger";
            break;
          default:
            color = "bg-gradient-info";
            break;
        }
    
        return <Badge className={color}>{selectedStatus}</Badge>;
      };
      

    const handleEditorChange = (value) => {
        setFormData((prevFormData) => ({
            ...prevFormData,
            offer_short_description: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        const { name, value } = e.target;

        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
        console.log(offerData);
        console.log(tags);
        
        // Simulate an asynchronous submission process
        try {
            const offerAdded = await addOffer(offerData);
            console.log(offerAdded);
            if (offerAdded.status === 200) {
                handleChange(offerAdded.data.result);

                if(offerData.id >0){
                    handleBadgeChange('offerId',offerData.id)
                    if(badges.id > 0){
                        const badgeAdded = await addOfferBadges(badges.id, badges);
                        console.log(badgeAdded);
                    }else{
                        const badgeAdded = await addOfferBadges(badges);
                        console.log(badgeAdded);
                    }
                    
                  
                    const tagsAdded = await addBulkOfferTags({ tags: tags });

                    if (tagsAdded.status === 200) {
                        setIsSubmitting(false);
                        setStep((prevStep) => prevStep + 1);
                        handleNextStep();
                        handleNextStep();
    
                    } else {
    
                    }

                }else{
                    const tagsAdded = await addBulkOfferTags({ offerId: offerAdded.data.result.id  , tags: tags });

                    if (tagsAdded.status === 200) {
                        setIsSubmitting(false);
                        setStep((prevStep) => prevStep + 1);
                        handleNextStep();
                        handleNextStep();
    
                    } else {
    
                    }
                }
                


            }

        } catch (error) {
            console.error('Error adding advertiser:', error);
        }
    };

    const handleUpdate = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        const { name, value } = e.target;

        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
            ['status']: selectedOfferStatus
        }));

        console.log(offerData);
        console.log(tags);
        
        // Simulate an asynchronous submission process
        try {
            const offerAdded = await updateOffer(offerData.id,offerData);
            console.log(offerAdded);

            const tagsAdded = await addBulkOfferTags({ offerId: offerData.id, tags });

            console.log(tagsAdded);
            if (tagsAdded.status === 200) {
                setIsSubmitting(false);
                setStep((prevStep) => prevStep + 1);
               

                fetchOfferTypes();
                fetchOfferStatus();

                handleNextStep();
                // handleNextStep();

            } else {

            }
            if (offerAdded.status === 200) {
                handleChange(offerAdded.data.result);
                if(badges.id >0 ){
                    const badgeAdded = await updateOfferBadges(badges.id, badges);
                    console.log(badgeAdded);
                }else{
                    if(badges.text!= ""){
                        const badgeAdded = await addOfferBadges(badges);
                        console.log(badgeAdded);
                    }
                    
                }


                
              




            }

        } catch (error) {
            console.error('Error adding advertiser:', error);
        }
    };

    const handleBack = () => {
        setStep((prevStep) => prevStep - 1);
    };

    const handleContinue = () => {
        setStep((prevStep) => prevStep + 1);
    };
    const handleTagChange = (index, field, value) => {
        const updatedTags = [...tags];
        updatedTags[index][field] = value;
        updatedTags[index]['offerId'] = offerData.id;
        setTags(updatedTags);
    };

    const handleBadgeChange = (field, value) => {
        const updatedTags = { ...badges };
        updatedTags[field] = value;
        updatedTags['offerId'] = offerData.id;
        setBadges(updatedTags);
    };
    const handleCheckboxChange = () => {
        const updatedTags = { ...badges };
        updatedTags.isActive = !updatedTags.isActive;
        updatedTags['offerId'] = offerData.id;
        console.log(updatedTags);
        setBadges(updatedTags);
      };
    
    // const handleUpdateStatus = (offerId, newStatus) => {
    //     // Perform API call to update the status
    //     // ...
      
    //     // Update the data state with the new status
    //     // const updatedData = data.map((item) => {
    //     //   if (item.id === offerId) {
    //     //     return { ...item, status: newStatus };
    //     //   }
    //     //   return item;
    //     // });zz
    //     // setData(updatedData);
      
    //     // Reset the selected status
    //     setSelectedOfferStatus('');
    //   };
      
    const handleAddTag = () => {
        setTags([...tags, { text: '', textColor: '#ffffff', backgroundColor: '#000000' }]);
    };

    const handleDeleteTag = async (index) => {
        const updatedTags = [...tags];
        updatedTags.splice(index, 1);
        setTags(updatedTags);


        if(tags[index].id > 0){
           await  deleteOfferTags(tags[index].id);
        }
    };

    const handleUpdateTag = async (index) => {
        // const updatedTags = [...tags];
        // updatedTags.splice(index, 1);
        // setTags(updatedTags);

        setIsPreLoaded(true);
        if(tags[index].id > 0){
         const node =  await  updateOfferTags(tags[index].id, tags[index]);
         if(node){
            setIsPreLoaded(false);
         }
        }
    };
    const {is_promotional, is_special_offer, enable_click_count} = offerData;
    
    return (
        <>
        <div>

        { 
        isPreloading ?
        (
            <LoadingSpinner />
        ):
        (
            <><div>
                                {notification && (
                                    <div className={`notification ${notification.type}`}>
                                        {notification.message}
                                    </div>
                                )}
                            </div><div className=''>
                                    <div className='mb-3 d-flex align-items-center justify-content-between'>
                                        <div>
                                            Enter Basic Details
                                        </div>

                                        {offerData.id > 0 ? (
                                            <>
                                                <span className="ms-auto">
                                                    <Dropdown isOpen={dropdownOpen} toggle={() => toggleDropdown()}>
                                                        <DropdownToggle caret className="custom-dropdown-toggle">
                                                            {renderBadge()}
                                                        </DropdownToggle>
                                                        <DropdownMenu>
                                                            {offerStatuses.map((status) => (
                                                                <DropdownItem
                                                                    key={status.value}
                                                                    onClick={() => handleStatusChange(status.value, offerData.id)}
                                                                >
                                                                    {status.label}
                                                                </DropdownItem>
                                                            ))}
                                                        </DropdownMenu>
                                                    </Dropdown>
                                                </span>
                                                <span className="ms-3 badge badge-success badge-sm my-auto text-dark">
                                                    Offer Id: <strong>{offerData.id}</strong>
                                                </span>
                                            </>
                                        ) : null}
                                    </div>



                                    <form>

                                        <fieldset className="custom-fieldset">
                                            <legend className="custom-legend">Basic Details</legend>
                                            <div className='row'>
                                                <div className='col-md-6'>
                                                    <FormGroup>
                                                        <Label for="name">Offer Name</Label>
                                                        <Input
                                                            type="text"
                                                            name="offer_name"
                                                            id="offer_name"
                                                            placeholder="Offer Name"

                                                            value={offerData.offer_name}
                                                            onChange={handleInputChange} />
                                                    </FormGroup>

                                                </div>
                                                <div className='col-md-6'>
                                                    <FormGroup>
                                                        <Label for="selectedOption">Offer Type</Label>
                                                        <InputGroup>
                                                            <Input
                                                                type="select"
                                                                name="offer_type"
                                                                id="offer_type"
                                                                value={offerData.offer_type}
                                                                onChange={handleInputChange}
                                                            >
                                                                {offerTypeData.map((offertype, index) => (
                                                                    <option key={index} value={offertype.name}>
                                                                        {offertype.name}
                                                                    </option>
                                                                ))}
                                                            </Input>
                                                            <InputGroupAddon addonType="append">
                                                                <Link to="/admin/offertype" addonType="append">
                                                                    <Button color="primary">
                                                                        <FaPlus />
                                                                    </Button>
                                                                </Link>
                                                            </InputGroupAddon>
                                                        </InputGroup>
                                                    </FormGroup>

                                                </div>
                                                <div className='col-md-6'>
                                                    <FormGroup>
                                                        <Label for="email">Package Name</Label>
                                                        <Input
                                                            type="text"
                                                            name="offer_package_name"
                                                            id="email"
                                                            placeholder="com.ai.pollpe"
                                                            value={offerData.offer_package_name}
                                                            onChange={handleInputChange} />
                                                    </FormGroup>
                                                </div>
                                                <div className="col-md-2">
                                                    <FormGroup>
                                                        <Label for="email">If this Offer is Ad</Label>
                                                        <CustomInput
                                                            type="switch"
                                                            id="isLocationTargetting"
                                                            name="is_promotional"
                                                            label="Promotional"
                                                            checked={is_promotional}
                                                            onChange={() => setFormData((prevFormData) => ({
                                                                ...prevFormData,
                                                                is_promotional: !prevFormData.is_promotional
                                                            }))} />
                                                    </FormGroup>
                                                </div>
                                                <div className="col-md-2">
                                                    <FormGroup>
                                                        <Label for="special_offer" className='text-green'>Mark this as Special Offer</Label>
                                                        <CustomInput
                                                            type="switch"
                                                            id="isSpecialOffer"
                                                            name="is_special_offer"
                                                            label="Special Offer"
                                                            checked={is_special_offer}
                                                            onChange={() => setFormData((prevFormData) => ({
                                                                ...prevFormData,
                                                                is_special_offer: !prevFormData.is_special_offer
                                                            }))} />
                                                    </FormGroup>
                                                </div>
                                                {is_special_offer && (

                                                    <div className="col-md-2">
                                                    <FormGroup>
                                                            <Label for="email">User Conversion Count</Label>
                                                            <Input
                                                                type="text"
                                                                name="user_conversion_count"
                                                                id="email"
                                                                placeholder="2"
                                                                value={offerData.user_conversion_count}
                                                                onChange={handleInputChange} />
                                                        </FormGroup>
                                                    </div>
                                                                                                        
                                                )}
                                               

                                            </div>
                                            <div className='row'>

                                                <div className='col-md-12'>
                                                    <FormGroup>
                                                        <Label for="email">Short Description</Label>
                                                        <ReactQuill
                                                            value={offerData.offer_short_description}
                                                            onChange={handleEditorChange}
                                                            theme="snow"
                                                            modules={modules}
                                                            placeholder="Write something awesome..." />
                                                    </FormGroup>

                                                </div>

                                            </div>
                                            <fieldset className="custom-fieldset">
                                                <legend className="custom-legend">Badge</legend>

                                              
                                                <div className='row mt-3'>
                                                    <div className="row">
                                                        <div className='col-md-3'>
                                                             <FormGroup className='col-md-3 text-align-cente align-items-center justify-content-start'>
                                                                <CustomInput
                                                                type="switch"
                                                                id="isActiveBadge"
                                                                name="badge"
                                                                label="Is Active"
                                                                checked={badges.isActive}
                                                                onChange={handleCheckboxChange} />
                                                            </FormGroup>
                                                        </div>
                                                        {badges.isActive && (

                                                        <>
                                                        <div className='col-md-8'>
                                                       
                                                        <div className='row'>
                                                        <FormGroup className='col-md-3'>

                                                            <Input
                                                                type="text"
                                                                value={badges.text}
                                                                onChange={(e) => handleBadgeChange('text', e.target.value)}
                                                                placeholder="Badge text" />
                                                            <label>Badge Text</label>
                                                            </FormGroup><FormGroup className='col-md-2'>

                                                                <Input
                                                                    type="color"
                                                                    value={badges.textColor}
                                                                    onChange={(e) => handleBadgeChange('textColor', e.target.value)}
                                                                    placeholder="Text color" />
                                                                <label>Text Color</label>
                                                            </FormGroup><FormGroup className='col-md-2'>

                                                                <Input
                                                                    type="color"
                                                                    value={badges.backgroundColor}
                                                                    onChange={(e) => handleBadgeChange('backgroundColor', e.target.value)}
                                                                    placeholder="Background color" />
                                                                <label>Background Color</label>
                                                         </FormGroup>
                                                         <div className='col-md-3'>

                                                         <fieldset className="custom-fieldset ">
                                                                <legend className="custom-legend">Preview</legend>
                                                         <div className='d-flex m-2 gap-2'>
                                                            {badges && (
                                                                <span className="badge " style={{ backgroundColor: badges.backgroundColor, color: badges.textColor }}>{badges.text}</span>
                                                            )}
                                                        </div>
                                                        </fieldset>
                                                         </div>

                                                        </div>
                                                        
                                                        </div></>
                                                         
                                                        )}

                                                    </div>

                                                </div>

                                            </fieldset>
                                            <fieldset className="custom-fieldset mt-3">
                                                <legend className="custom-legend">Tags</legend>
                                                <div className='d-flex m-2 gap-2'>
                                                    {tags.map((tag, index) => (
                                                        <span className="badge " style={{ backgroundColor: tag.backgroundColor, color: tag.textColor }}>{tag.text}</span>
                                                    ))}
                                                </div>
                                                <div className='row mt-3'>
                                                    {tags.map((tag, index) => (
                                                        <div key={index} className="row">
                                                            <FormGroup className='col-md-5'>

                                                                <Input
                                                                    type="text"
                                                                    value={tag.text}
                                                                    onChange={(e) => handleTagChange(index, 'text', e.target.value)}
                                                                    placeholder="Tag text" />
                                                                <label>Text</label>
                                                            </FormGroup>
                                                            <FormGroup className='col-md-2'>

                                                                <Input
                                                                    type="color"
                                                                    value={tag.textColor}
                                                                    onChange={(e) => handleTagChange(index, 'textColor', e.target.value)}
                                                                    placeholder="Text color" />
                                                                <label>Text Color</label>
                                                            </FormGroup>
                                                            <FormGroup className='col-md-2'>

                                                                <Input
                                                                    type="color"
                                                                    value={tag.backgroundColor}
                                                                    onChange={(e) => handleTagChange(index, 'backgroundColor', e.target.value)}
                                                                    placeholder="Background color" />
                                                                <label>Background Color</label>
                                                            </FormGroup>
                                                            <div className='col-md-1 form-group '>

                                                                <Button type="button" className='btn' onClick={() => handleDeleteTag(index)} color="danger">
                                                                    <i className='fas fa-trash'></i>
                                                                </Button>
                                                            </div>
                                                            <div className='col-md-1 form-group '>
                                                            <Button type="button" className='btn' onClick={() => handleUpdateTag(index)} color="success">
                                                                <i className='fas fa-upload'></i>
                                                            </Button>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                                <Button type="button" onClick={handleAddTag} color="primary">
                                                    Add Tag
                                                </Button>

                                            </fieldset>

                                            <fieldset className="custom-fieldset mt-3">
                                                <legend className="custom-legend">Offer Icon</legend>
                                                <div className='row'>
                                                    <div className='col-md-6'>
                                                        <FormGroup>
                                                            <Label for="name">Small Icon</Label>
                                                            <Input
                                                                type="text"
                                                                name="offer_small_icon"
                                                                id="name"
                                                                placeholder="Small Icon"
                                                                value={offerData.offer_small_icon}
                                                                onChange={handleInputChange} />
                                                        </FormGroup>

                                                    </div>
                                                    <div className='col-md-6'>
                                                        <FormGroup>
                                                            <Label for="email">Banner Image</Label>
                                                            <Input
                                                                type="text"
                                                                name="offer_banner_image"
                                                                id="email"
                                                                placeholder="Large Icon"
                                                                value={offerData.offer_banner_image}
                                                                onChange={handleInputChange} />
                                                        </FormGroup>
                                                    </div>

                                                </div>

                                            </fieldset>

                                        </fieldset>


                                        <fieldset className="custom-fieldset mt-3">
                                            <legend className="custom-legend">Revenue and Payouts</legend>

                                            <div className='row'>
                                                <div className='col-md-6'>
                                                    <FormGroup>
                                                        <Label for="email">Revenue</Label>
                                                        <Input
                                                            type="number"
                                                            name="offer_revenue"
                                                            id="title"
                                                            placeholder="1000"
                                                            value={offerData.offer_revenue}
                                                            onChange={handleInputChange}
                                                            disabled={true} />
                                                    </FormGroup>

                                                </div>
                                                <div className='col-md-6'>
                                                    <FormGroup>
                                                        <Label for="email">Payout</Label>
                                                        <Input
                                                            type="number"
                                                            name="offer_payout"
                                                            id="title"

                                                            placeholder="600"
                                                            value={offerData.offer_payout}
                                                            onChange={handleInputChange}
                                                            disabled={true} />
                                                    </FormGroup>

                                                </div>
                                            </div>

                                        </fieldset>
                                        <fieldset className="custom-fieldset mt-3">
                                            <legend className="custom-legend">User Reward</legend>

                                            <div className='row'>
                                                <div className='col-md-6'>
                                                    <FormGroup>
                                                        <Label for="email">Payout</Label>
                                                        <Input
                                                            type="number"
                                                            name="offer_user_reward"
                                                            id="title"
                                                            placeholder="1000"
                                                            value={offerData.offer_user_reward}
                                                            onChange={handleInputChange}
                                                            disabled={true} />
                                                    </FormGroup>

                                                </div>

                                            </div>

                                        </fieldset>

                                        <fieldset className="custom-fieldset mt-3">
                                            <legend className="custom-legend">Offer Setting</legend>

                                            <div className='row'>
                                                <div className='col-md-6'>
                                                    <FormGroup>
                                                        <Label for="email">Enable/Disable Click Count</Label>
                                                        <CustomInput
                                                            type="switch"
                                                            id="enableClickCount"
                                                            name="is_special_offer"
                                                            label="Click Count"
                                                            checked={enable_click_count}
                                                            onChange={() => setFormData((prevFormData) => ({
                                                                ...prevFormData,
                                                                enable_click_count: !prevFormData.enable_click_count
                                                            }))} />
                                                    </FormGroup>

                                                </div>

                                            </div>

                                        </fieldset>

                                        <div className="d-flex justify-content-center  mt-3">


                                            {(step === 1 && offerData.id === 0) && (
                                                <Button type="submit" color="primary" disabled={isSubmitting} onClick={handleSubmit}>
                                                    {isSubmitting ? <Spinner size="lg" color="light" /> : 'Continue'}
                                                </Button>
                                            )}
                                            {(step === 1 && offerData.id > 0) && (
                                                <Button type="button" color="success" disabled={isSubmitting} onClick={handleUpdate}>
                                                    {isSubmitting ? <Spinner size="lg" color="light" /> : 'Update & Continue'}
                                                </Button>
                                            )}


                                        </div>
                                    </form>
                                </div></>
        )
        }
        </div>
       </>
      

    );
};

export default Step1Form;
